import { Component, Input } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { BaseSelectFormFieldComponent } from "../base-select-form.field.component";
import { camelCaseToDisplayString } from "src/services/utils/string.utils";

@Component({
  selector: "rc-single-select-form-field",
  templateUrl: "../base-select-form-field.component.html",
  styleUrls: ["./single-select-form-field.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: SingleSelectFormFieldComponent,
    },
  ],
  standalone: false,
})
export class SingleSelectFormFieldComponent extends BaseSelectFormFieldComponent<string> {
  @Input() public initialValue: string;

  public constructor() {
    super(false);
  }

  protected toDisplayValue(input: string): string {
    const index = this.possibleValues.indexOf(input);
    return this.possibleValuesLabels?.[index] ?? camelCaseToDisplayString(input);
  }

  public readonly camelCaseToDisplayString = camelCaseToDisplayString;
}
